import { z } from 'zod'

/** The word that has to be typed to clear a venue. */
export const VENUE_PURGE_WORD = 'DELETE'

/**
 * Delete every event at one venue, and optionally the client contacts on them.
 *
 * Irreversible and plural, so the word has to be sent: it is the difference
 * between a request that meant to clear a season of bookings and one that arrived
 * by accident. `clients` has no default for the same reason — the caller states
 * what should happen to the people on those events rather than inheriting an
 * answer.
 */
export const purgeVenueEventsInputSchema = z
  .object({
    confirm: z.literal(VENUE_PURGE_WORD, { message: `Type ${VENUE_PURGE_WORD} to confirm.` }),
    clients: z.enum(['keep', 'remove']),
  })
  .strict()

export type PurgeVenueEventsInput = z.infer<typeof purgeVenueEventsInputSchema>
